import request, { download } from "@/utils/request";

// 查询班级列列表
export function listClass (query) {
  return request({
    url: "/system/class/new/page",
    method: "post",
    data: query,
    headers: { repeatSubmit: false },
  });
}

// 查询班级列详细
export function getClass (id) {
  return request({
    url: "/system/new/class/" + id,
    method: "get",
    headers: { repeatSubmit: false },
  });
}

// 添加/编辑班级列表
export function updateClass (data) {
  return request({
    url: "/system/class/new/save",
    method: "post",
    data: data,
    showLoading:true
  });
}

// 删除班级列
export function delClass (id) {
  return request({
    url: "/system/class/new/" + id,
    method: "delete",
  });
}

// 查询大区/区域/校区
export function listRegion () {
  return request({
    url: "/system/region/tree",
    method: "get",
    headers: { repeatSubmit: false },
  });
}
//查询所有校区
export function listRegionAll () {
  return request({
    url: "/system/region/getRegisterSchool",
    method: "get",
    headers: { repeatSubmit: false },
  });
}
// 查询科目信息
export function listSubject (params) {
  return request({
    url: "/system/subject/list",
    method: "get",
    params: params,
    headers: { repeatSubmit: false },
  });
}

// 查询企业信息
export function listEnterprise (data) {
  return request({
    url: "/system/enterprise_management/search",
    method: "post",
    data
  });
}

// 查询班级信息详情
export function getDetail (id) {
  return request({
    url: "/system/class/new/" + id,
    method: "get",
    showLoading:true
  });
}

// 用户模板详情/根据班级id查询班级详情及课程表信息
export function getTemplateClassDetail (id) {
  return request({
    url: "/system/class/new/user/template/id/" + id,
    method: "get",
    showLoading:true
  });
}
// 查询班级课程表信息
export function getSchedule (id) {
  return request({
    url: "/system/class/new/classSchedule/" + id,
    method: "get",
  });
}

// 查询班级学员信息
export function getStudent (id) {
  return request({
    url: "/system/class/new/class/student/" + id,
    method: "get",
  });
}

//查询上课教室
export function getClassroomList (params) {
  return request({
    url: "/system/calss/room/list",
    method: "get",
    params: params,
  });
}

//查询班级学员信息
export function getStudentByClassId (params) {
  return request({
    url: `/system/class/new/all/student/${params.classId}`,
    method: "get",
    params: params,
  });
}
//查询班级已保存学员信息
export function getSaveStudentByClassId (params) {
  return request({
    url: `/system/class/new/class/student/${params.classId}`,
    method: "get",
  });
}
//下载学生导入模板
export function getStudentTemplate () {
  return download(
    `/system/class/new/export/template`,
    {},
    `班级学员列表模板_${new Date().getTime()}.xlsx`
  );
}
//导入班级学员
export function importStudentTemplate (data) {
  console.log(data)
  return request({
    url: "/system/class/new/class/student/import",
    method: "post",
    data: data,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  });
}
//保存学员
export function saveStudent (data) {
  return request({
    url: "/system/class/new/student/save",
    method: "post",
    data: data,

  });
}

// 根据id查询排班详情
export function scheduleDetail (ID) {
  return request({
    url: `/system/class/new/schedule/${ID}`,
    method: "get",
  });
}


//保存排班
export function scheduleSave (data) {
  return request({
    url: `/system/class/new/schedule/save`,
    method: "post",
    data
  });
}


// 根据classId查询课程表
export function getCourseListByClassId (classId) {
  return request({
    url: `/system/class/new/classSchedule/${classId}`,
    method: "get",
    showLoading: true
  });
}

// 根据classId查询课程表
export function getStudentListByClassId (classId) {
  return request({
    url: `/system/class/new/class/student/${classId}`,
    method: "get",
  });
}

//删除一对一课次
export function deleteCourse (id) {
  return request({
    url: `/system/class/new/delete/course/${id}`,
    method: 'post'
  })
}

//批量添加课程
export function addClassCoure (id, data) {
  return request({
    url: `/system/class/new/add/course/${id}`,
    method: 'post',
    data
  })
}


//修正科目 预排
export function getAmendSubject (data) {
  return request({
    url: '/system/class/new/amend/subject',
    method: 'post',
    data
  })
}

//检验时间
export function checkTime(data) {
  return request({
    url: `/system/class/new/check/time`,
    method: 'post',
    data,
    headers: { repeatSubmit: false },
  })
}


//班级状态
export function changeStatus(data) {
  return request({
    url: `/system/class/new/enable/or/disable`,
    method: 'post',
    data,
    headers: { repeatSubmit: false },
  })
}

// 设置课后测时间
export function saveKqcTime(data) {
  return request({
    url: `/system/kcb/setkqcexamtime`,
    method: 'post',
    data,
  })
}

// 修改销售计划
export function salesPlanNumEdite(data) {
  return request({
    url: `/system/class/new/edite/salesPlanNum`,
    method: 'post',
    data,
  })
}

// 批量修改老师
export function changeScheduleTeacher(data) {
  return request({
    url: `/system/class/new/schedule/teacher`,
    method: 'post',
    data,
  })
}


//分页查询用户模板
export function pageTemplateApi(data) {
  return request({
    url: `/system/class/new/user/template/page`,
    method: 'post',
    data,
    headers: { repeatSubmit: false },
    showLoading:true
  })
}
//班级信息
export function getClassInfoByIdApi(classId, courseId = "") {
  return request({
    url: `/system/class/new/user/template/id/${classId}`,
    method: 'get',
    headers: { repeatSubmit: false },
    showLoading:true,
    params: { courseId }
  })
}

// 排课顺延
export function extendScheduleCourse(data) {
  return request({
    url: `/system/class/course/extend/schedule/course`,
    method: 'post',
    headers: { repeatSubmit: false },
    data,
    showLoading:true,
  });
}

// 排课顺延保存
export function extendScheduleSave(data) {
  return request({
    url: `/system/class/course/extend/schedule/save`,
    method: 'post',
    headers: { repeatSubmit: false },
    data
  });
}

// 查询直播课校区id
export function getLivingCampusId() {
  return request({
    url: `/system/class/new/get/living/campusId`,
    method: 'get',
    headers: { repeatSubmit: false },
  });
}


// 查询校区省份地市树形结构数据
export function cityTreeApi() {
  return request({
    url: `/system/region/city/tree`,
    method: 'get',
    headers: { repeatSubmit: false },
  });
}
//查询用户权限
export function checkUserPermission() {
  return request({
    url: `/system/class/new/check/permission`,
    method: 'post',
    headers: { repeatSubmit: false },
  });
}

// 修改班级课表推送范围
export function updateClassPushAreaApi(data) {
  return request({
    url: `/system/class/new/updateClassPushArea`,
    method: 'post',
    data,
    headers: { repeatSubmit: false },
  });
}

//课表推送
export function pushClassTimetable(data) {
  return request({
    url: `/system/class/new/pushClassTimetable`,
    method: 'post',
    data,
    headers: { repeatSubmit: false },
  });
}

//通过ids查询班级
export function getClassByIds(data) {
  return request({
    url: `/system/class/new/class/ids`,
    method: 'post',
    data,
    headers: { repeatSubmit: false },
  });
}

// 班级直播列表查询
export function findLiveList(courseId) {
  return request({
      url: `/newschool/liveStreamRoom/listByCourseId?courseId=${courseId}`,
      method: 'post',
  })
}

//查询单个
export function getOne(id) {
  return request({
    url: `/newschool/liveStreamRoom/detail?roomId=${id}`,
    method: 'post',
  })
}

//删除直播间
export function doDelLive(id) {
  return request({
    url: `/newschool/liveStreamRoom/delete?roomId=${id}`,
    method: 'post',
  })
}

// 保存直播间
export function saveLiveRoom(data) {
  if (data.roomId) {
    return request({
      url: `/newschool/liveStreamRoom/edit`,
      method: 'post',
      data
    })
  }
  return request({
    url: `/newschool/liveStreamRoom/add`,
    method: 'post',
    data
  })
}

// 保存批量选班
export function saveBatchChoose(data) {
  return request({
    url: `/system/class/new/liveSelection/save`,
    method: 'post',
    data,
  });
}

// 批量选班--导入
export function batchChooseImport(data) {
  return request({
    url: "/system/class/new/liveSelection/import",
    method: "post",
    data: data,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  });
}

// 查询--直播批量选班
export function findBatchChoose(classId) {
  return request({
    url: `/system/class/new/liveSelection/list?classId=${classId}`,
    method: 'post',
  });
}

// 直播保存文件
export function saveLiveFile(data) {
  return request({
    url: `newschool/liveStreamRoom/saveMaterials`,
    method: 'post',
    params: data
  })
}
